<template>
<v-dialog v-model="dialog" max-width="820px" persistent>
    <v-card flat tile color="primary">
        <v-card-title class="important white--text" height="50">
            Billing details for {{ organization_name }}
        </v-card-title>
        <v-form ref="add_bill_form" v-model="valid_billing" autocomplete="off">
            <v-container fluid style="background-color: #f5f5f5;" :class="{ 'px-0': $vuetify.breakpoint.smAndDown, 'pt-4': true}">
                <v-row no-gutters>
                    <!-- card variant -->
                    <v-col cols="6" md="6" class="px-2 py-1">
                        <v-card class="elevation-1 pa-2">
                            <div :class="{'error-rules': billingName}">
                                <div class="detail font-weight-bold pa-0 ma-0">Name <span v-if="billingName" class="red--text">*{{ billing_name_error }}</span></div>
                                <v-text-field v-model="item.name" ref="billingName" class="im-select ma-0" required solo flat clearable :rules="rules.billing_name" placeholder="Enter your name here" hide-details />
                            </div>
                        </v-card>
                    </v-col>
                    <v-col cols="6" md="6" class="px-2 py-1">
                        <v-card class="elevation-1 pa-2">
                            <div :class="{'error-rules': billingType}">
                                <div class="detail font-weight-bold pa-0 ma-0">Type</div>
                                <v-select class="im-select pa-0 ma-0" flat solo :items="billing_types" v-model="item.type" ref="billingType" placeholder="Select type" required clearable :rules="rules.type" :menu-props="{transition:'scale-transition', 'offset-y': ''}"
                                    hide-details />
                            </div>
                        </v-card>
                    </v-col>
                    <v-col cols="6" md="6" class="px-2 py-1">
                        <v-card class="elevation-1 pa-2">
                            <div :class="{'error-rules': billingFiscal}">
                                <div class="detail font-weight-bold pa-0 ma-0">Fiscal code</div>
                                <v-text-field v-model="item.fiscal_code" ref="billingFiscal" class="im-select ma-0" solo flat clearable required :rules="rules.fiscal_code" placeholder="Enter the fiscal code." hide-details />
                            </div>
                        </v-card>
                    </v-col>
                    <v-col cols="6" md="6" class="px-2 py-1">
                        <v-card class="elevation-1 pa-2">
                            <div :class="{'error-rules': billingRegistry}">
                                <div class="detail font-weight-bold pa-0 ma-0">Registry number</div>
                                <v-text-field v-model="item.registry_number" ref="billingRegistry" class="im-select ma-0" solo flat clearable required :rules="rules.registry_number" placeholder="Enter the registry number." hide-details />
                            </div>
                        </v-card>
                    </v-col>
                    <v-col cols="6" md="6" class="px-2 py-1">
                        <v-card class="elevation-1 pa-2">
                            <div :class="{'error-rules': billingEmail}">
                                <div class="detail font-weight-bold">Email</div>
                                <v-text-field v-model="item.email" ref="billingEmail" class="im-select ma-0" solo flat clearable required :rules="rules.email" placeholder="Enter your email here" hide-details />
                            </div>
                        </v-card>
                    </v-col>
                    <v-col cols="6" md="6" class="px-2 py-1">
                        <v-card class="elevation-1 pa-2">
                            <div class="detail font-weight-bold pa-0 ma-0">Point of bussines</div>
                            <v-text-field v-model="item.point_of_business" class="im-select ma-0 pa-0" solo flat clearable placeholder="Enter your point of business" hide-details />

                        </v-card>
                    </v-col>
                    <!-- ./ card variant  -->
                    <v-col cols="12" class="px-2 py-1">
                        <v-card class="elevation-1 pa-2">
                            <div class="detail font-weight-bold">
                                <v-row no-gutters justify="space-between">
                                    <div>Banks</div>
                                    <v-icon color="blue" @click="addBank()">add_circle</v-icon>
                                </v-row>
                            </div>
                            <v-row no-gutters class="pt-2 im-search">
                                <v-col cols="12">
                                    <v-row no-gutters v-for="(bank, index) in item.banks" :key="index">
                                        <v-col cols="6" class="px-1">
                                            <v-text-field v-model="bank.name" class="ma-0 pa-0" :rules="rules.bank_name" required label="Bank name" />
                                        </v-col>
                                        <v-col cols="4" class="px-1">
                                            <v-text-field v-model="bank.account" class="ma-0  pa-0" :rules="rules.bank_account" required label="Bank Account" />
                                        </v-col>
                                        <v-col cols="2" class="px-1">
                                            <div class="d-flex">
                                                <v-text-field class="ma-0 pa-0" v-model="bank.currency" :rules="rules.bank_currency" label="Currency" required />
                                                <v-icon size="24" color="red" class="pl-2 pb-2" @click="removeBank(index)">delete</v-icon>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>

                        </v-card>
                    </v-col>
                    <v-col cols="12" class="px-2 py-1">
                        <v-card class="elevation-1 pa-2">
                            <div class="detail font-weight-bold">Address</div>
                            <v-row no-gutters class="pt-2 im-search">
                                <v-col cols="12" md="6">
                                    <v-row no-gutters>
                                        <v-col cols="12" class="px-1">
                                            <v-text-field v-model="item.address.city" class="ma-0 pa-0" label="City" />
                                        </v-col>
                                        <v-col cols="8" class="px-1">
                                            <v-text-field v-model="item.address.region" class="ma-0 pa-0" label="Region" />
                                        </v-col>
                                        <v-col cols="3" class="px-1">
                                            <v-select class="im-select" v-model="item.address.country" :items="countries" clearable label="Country" :menu-props="{transition:'scale-transition', 'offset-y': ''}" hide-details style="margin-top:2px" />
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-row no-gutters>
                                        <v-col cols="12" class="px-1">
                                            <v-text-field v-model="item.address.street" class="ma-0 pa-0" label="Street" />
                                        </v-col>
                                        <v-col cols="4" class="px-1">
                                            <v-text-field v-model="item.address.number" class="ma-0 pa-0" label="Number" />
                                        </v-col>
                                        <v-col cols="4" class="px-1">
                                            <v-text-field v-model="item.address.building" class="ma-0 pa-0" label="Building" />
                                        </v-col>
                                        <v-col cols="4" class="px-1">
                                            <v-text-field v-model="item.address.postal_code" class="ma-0 pa-0" label="Postal Code" />
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>

                    <v-col cols="12" class="px-2 py-1">
                        <v-card class="elevation-1 pa-2">
                            <div class="detail font-weight-bold pa-0 ma-0">Contact</div>
                            <v-row no-gutters class="pt-2 im-search">
                                <v-col cols="6" class="px-1">
                                    <v-text-field v-model="item.contact.name" class="ma-0 pa-0" label="Name" clearable />
                                </v-col>
                                <v-col cols="6" class="px-1">
                                    <v-text-field v-model="item.contact.position" class="ma-0  pa-0" label="Position" clearable />
                                </v-col>
                                <v-col cols="6" class="px-1">
                                    <v-text-field class="ma-0 pa-0" v-model="item.contact.email" label="Email" clearable hide-details />
                                </v-col>
                                <v-col cols="6" class="px-1">
                                    <v-text-field class="ma-0 pa-0" v-model="item.contact.phone" label="Phone" clearable hide-details @ />
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="emitExit()">Cancel</v-btn>
                    <v-btn color="primary" @click="save()">Save</v-btn>
                </v-card-actions>
            </v-container>
        </v-form>
    </v-card>
</v-dialog>
</template>

<script>
import {
    mapActions
} from 'vuex';
import defaults from "../../utils/PropDefaults.js";

export default {
    props: {
        dialog: {
            type: Boolean,
            default: true
        },
        billing_id: [Number, String],
        organization_id: [Number, String],
        organization_name: String,
    },
    components: {},
    data() {
        return {
            // test values
            billingName: false,
            billingType: false,
            billingFiscal: false,
            billingRegistry: false,
            billingEmail: false,
            billing_name_error: null,
            valid_billing: false,

            countries: [
                "RO",
            ],

            service: {},
            item: defaults.billing_item,

            billing_types: [
                {
                    text: "Physical",
                    value: "physical"
                }, {
                    text: "Legal",
                    value: "legal"
                }
            ],

            rules: {
                type: [v => !!v || "Type is required."],
                billing_name: [v => !!v || "Billing name is required"],
                email: [
                    v => !!v || "E-mail is required",
                    v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || "E-mail must be valid"
                ],
                fiscal_code: [v => !!v || "Fiscal code is required"],
                registry_number: [v => !!v || "Registry number is required"],
                point_of_business: [v => !!v || "Point of business is required"],
                bank_name: [v => !!v || "Bank name is required"],
                bank_account: [v => !!v || "Bank account is required"],
                bank_currency: [
                    v => !!v || "Currency is required",
                    v => /^[a-zA-Z]{3}$/.test(v) || "Currency must be 3 character"
                ],
                address_country: [
                    v => !!v || "Address country is required",
                    v => /^[a-zA-Z]{2}$/.test(v) || "Country must be 2 character"
                ],
                address_city: [v => !!v || "Address city is required"],
                address_state: [v => !!v || "Address state is required"],
                address_street: [v => !!v || "Address street is required"],
                address_number: [v => !!v || "Address number is required"],
                address_building: [
                    v => !!v || "Address building is required"
                ],
                address_postal_code: [v => !!v || "Address postal code is required"],
                contact_name: [v => !!v || "Contact person name is required"],
                contact_position: [v => !!v || "Contact person position is required"]
            },
        }
    },

    watch: {
        billing_id: {
            handler() {
                if(this.billing_id) {
                    this.getItem();
                } else {
                    this.billing = this.$clone(defaults.billing_item);
                }
            }
        },

    },
    methods: {

        ...mapActions('alert', ['success', 'error']),

        getItem() {
            if(!this.billing_id) {
                return
            }
            // prepare endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/profiles/billings/" + this.billing_id;

            this.$axios.get(endpoint)
                .then(response => {
                    this.item = response.data;
                })
                .catch(error => {
                    this.error("Oops, something went wrong!");
                    console.log(error);
                })
        },

        save() {
            this.billingName = this.$refs.billingName.hasError;
            this.billingType = this.$refs.billingType.hasError;
            this.billingFiscal = this.$refs.billingFiscal.hasError;
            this.billingRegistry = this.$refs.billingRegistry.hasError;
            this.billingEmail = this.$refs.billingEmail.hasError;
            // prepare for edit sau add
            if(!this.$refs.add_bill_form.validate()) {
                return
            }
            // prepare endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/profiles/billings";

            // preapare the model for saving
            let bill = this.item;
            Object.keys(bill)
                .forEach(function (key) {
                    if(bill[key] === undefined || bill[key] == "" || bill[key] === null) {
                        delete bill[key];
                    }
                    if(key == "contact" || key == "address") {
                        let obj_aux = bill[key];
                        Object.keys(obj_aux)
                            .forEach(function (key_aux) {
                                if(obj_aux[key_aux] === undefined || obj_aux[key_aux] == "" || obj_aux[key_aux] === null) {
                                    delete bill[key][key_aux];
                                }
                            });
                    }
                });

            let bill_model = {
                resource_id: this.organization_id,
                resource_type: "organization",
                data: bill
            }

            if(this.item.id) {
                this.$axios.put(endpoint + "/" + this.item.id, bill_model) // eslint-disable-next-line
                    .then(response => {
                        this.success("Billing edited.");
                        this.$emit('refresh');
                        this.emitExit();
                    })
                    .catch(error => {
                        this.error("Oops, something went wrong!");
                        console.error(error);
                    })
                    .finally(() => {});
            } else {
                delete bill_model.data.id;
                delete bill_model.data.owner_id;
                this.$axios.post(endpoint, bill_model) // eslint-disable-next-line
                    .then(response => {
                        this.success("Billing added.");
                        this.$emit('refresh');
                        this.emitExit();
                    })
                    .catch(error => {
                        this.error("Oops, something went wrong!");
                        console.error(error);
                    })
                    .finally(() => {});
            }
        },

        addBank() {
            this.item.banks.push({
                name: null,
                account: null,
                currency: null
            });
        },

        removeBank(key) {
            if(key != 0) {
                this.item.banks.splice(key, 1);
            }
        },

        emitExit() {
            this.billingName = false;
            this.billingType = false;
            this.billingFiscal = false;
            this.billingRegistry = false;
            this.billingEmail = false;
            this.$refs.add_bill_form.reset()
            this.$emit('exit');
        },

    }
}
</script>
<style>
.pointer {
    cursor: pointer;
}
</style>
